type Props = { onOpenConsult: () => void };

export default function SectionBooking({ onOpenConsult }: Props) {
  return (
    <>
      <section id="contact" className="relative py-space-ds-section-standard md:py-space-ds-section-standard-md bg-brand-soft">
        <div className="w-full px-6 md:px-10">
          <div className="max-w-[1440px] mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
              <div className="lg:col-span-6">
                <div className="text-ds-eyebrow text-brand mb-space-ds-intro-eyebrow-heading">
                  08 · Booking & Contact
                </div>
                <h2 className="text-ds-conversion-heading font-medium text-ink max-w-[560px]">
                  Ready when you are.
                </h2>
                <p className="mt-5 text-ds-body text-ink-muted max-w-[440px]">
                  Start with a consultation, or ask us a question first.
                </p>

                <div className="flex flex-wrap gap-3 mt-8">
                  <button
                    onClick={onOpenConsult}
                    className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-brand text-white text-ds-control font-medium hover:bg-[#027ea3] transition whitespace-nowrap cursor-pointer"
                  >
                    Book a Consultation
                    <i className="ri-arrow-right-line text-sm" />
                  </button>
                  <button
                    onClick={onOpenConsult}
                    className="inline-flex items-center gap-2 px-5 py-3 rounded-md border border-ink text-ink text-ds-control font-medium hover:bg-white transition whitespace-nowrap cursor-pointer"
                  >
                    Online Consultation
                  </button>
                </div>
              </div>

              <div className="lg:col-span-6">
                <div className="w-full aspect-[4/3] rounded-editorial overflow-hidden bg-white">
                  <img
                    src="https://public.readdy.ai/ai/img_res/edited_6bf69203d96f0633cc139a5152b39830_12421d0e.jpg"
                    alt="Aline Dental clinic entrance"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>

            <div className="mt-space-ds-subsection-divider md:mt-space-ds-subsection-divider-md grid grid-cols-2 gap-8 lg:grid lg:[grid-template-columns:repeat(4,max-content)] lg:justify-between lg:gap-8 text-ds-meta text-ink border-t border-ink/10 pt-10">
              <div>
                <div className="text-ds-eyebrow tracking-[0.2em] text-brand mb-space-ds-micro-label-value">Address</div>
                <div>Aline Dental</div>
                <div className="text-ink-muted">14 Wester Straat, 1017 CT</div>
                <div className="text-ink-muted">Amsterdam, NL</div>
              </div>
              <div>
                <div className="text-ds-eyebrow tracking-[0.2em] text-brand mb-space-ds-micro-label-value">Contact</div>
                <div>+31 20 220 4180</div>
                <div className="text-ink-muted">WhatsApp · +31 6 4402 1120</div>
                <div className="text-ink-muted">hello@aline-dental.com</div>
              </div>
              <div>
                <div className="text-ds-eyebrow tracking-[0.2em] text-brand mb-space-ds-micro-label-value">Opening Hours</div>
                <div>Mon – Fri · 08:30 – 19:00</div>
                <div className="text-ink-muted">Sat · 09:00 – 14:00</div>
                <div className="text-ink-muted">Sun · Closed</div>
              </div>
              <div>
                <div className="text-ds-eyebrow tracking-[0.2em] text-brand mb-space-ds-micro-label-value">Emergencies</div>
                <div>Existing patients only</div>
                <div className="text-ink-muted">24/7 line · +31 6 4402 8899</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="py-10 bg-white border-t border-gray-100">
        <div className="w-full px-6 md:px-10">
          <div className="max-w-[1440px] mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-ds-caption text-ink-muted">
            <div className="flex items-center gap-2.5">
              <span className="w-7 h-7 flex items-center justify-center text-ink">
                <svg width="24" height="24" viewBox="0 0 32 32" fill="none" aria-hidden="true">
                  <path d="M16 5c-3 0-5 1-7 1-2 0-3.2 1.3-3.2 3.3 0 3.1 1 6.9 2.3 10.3 1 2.5 1.9 4.7 2.8 6 .6.9 1.2 1.4 1.9 1.4 1 0 1.4-.9 2-2.8.5-1.7 1-2.5 1.2-2.9.3-.3.6-.5 1-.5s.7.2 1 .5c.2.4.7 1.2 1.2 2.9.6 1.9 1 2.8 2 2.8.7 0 1.3-.5 1.9-1.4.9-1.3 1.8-3.5 2.8-6 1.3-3.4 2.3-7.2 2.3-10.3C28.2 7.3 27 6 25 6c-2 0-4-1-7-1Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" strokeLinecap="round" />
                </svg>
              </span>
              <span className="text-[14px] leading-none">
                <span className="font-semibold text-ink">Aline</span>
                <span className="font-light text-ink-muted ml-1">dental</span>
              </span>
              <span className="ml-1">· © 2026 · Amsterdam</span>
            </div>
            <div className="flex items-center gap-6">
              <a href="#top" className="hover:text-ink cursor-pointer">Privacy</a>
              <a href="#top" className="hover:text-ink cursor-pointer">Terms</a>
              <a href="#top" className="hover:text-ink cursor-pointer">Imprint</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}